export class EmployeeMaster {
  public EMPLOYEE_ID!: number;
  public EMPLOYEE_CODE!: string;
  public EMPLOYEE_NAME!: string;
  public DEP_ID!: number;
  public DESG_ID!: number;
  public MOBILE_NO!: string;
  public DOJ!: string;
  public LEDGER_NAME!: string;
  public EMAIL_ID!: string;
  public EMP_SHIFT!: string;
  public ACTIVITY_ID!: number;
  public OUT_ACTIVITY!: string;
  public LOC_CODE!: string;
  public CREATEDBY_USERID!: number;
  public UPDATEDBY_USERID!: number;
  public CREATED_DATE!: string;
  public UPDATED_DATE!: string;
  public IS_ACTIVE!: Boolean;
}
